import React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import parseISO from "date-fns/parseISO";
import format from "date-fns/format";

const columns = [
  { id: "external_id", label: "Job ID", minWidth: 170 },
  { id: "state", label: "Status", minWidth: 100 },
  { id: "printer_id", label: "Printer ID", minWidth: 100 },
  {
    id: "created_at",
    label: "Created",
    minWidth: 100,
    format: (value) => format(parseISO(value), "Pp"),
  },
];

const Jobs = ({ jobsData, searchParams, setSearchParams, meta: { total } }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleChangePage = (event, newPage) => {
    event.preventDefault();
    setSearchParams({ ...searchParams, page: newPage });
  };

  const handleChangeRowsPerPage = (event) => {
    setSearchParams({ ...searchParams, page: 0, per: +event.target.value });
  };

  const handleOnClick = (id) => (event) => {
    event.preventDefault();
    navigate(`/user/jobs/${id}`);
  };

  return (
    <Paper elevation={0} sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {jobsData.length > 0 ? (
            <TableBody>
              {jobsData.map((jobData, i) => {
                return (
                  <TableRow
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={i}
                    onClick={handleOnClick(jobData.id)}
                    sx={{ cursor: "pointer" }}
                  >
                    {columns.map((column) => {
                      const value = jobData.attributes[column.id];

                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format ? column.format(value) : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          ) : (
            <TableBody>
              <TableRow>
                <TableCell align={"center"} colSpan={columns.length}>
                  <Typography variant={"h5"} sx={{ py: theme.spacing(4) }}>
                    No search results
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50]}
        component={"div"}
        count={total}
        rowsPerPage={searchParams.per}
        page={searchParams.page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
};

Jobs.propTypes = {
  meta: PropTypes.shape({}).isRequired,
  jobsData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  searchParams: PropTypes.shape({}).isRequired,
  setSearchParams: PropTypes.func.isRequired,
};

export default Jobs;
